import { Card as MuiCard, CardActionArea as MuiCardActionArea, styled } from '@mui/material'

export const Card = styled(MuiCard)({
  width: '350px',
  height: '250px',
  maxWidth: '100%',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  borderRadius: '20px',
  background: '#313A71',
  margin: '0 auto',
})

export const CardActionArea = styled(MuiCardActionArea)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
})
